import { createContext, useContext } from "react";

/**
 * Whether the signed-in user is the VP named on the counterparty or broker currently being
 * viewed. Provided by the counterparty and broker detail pages, which already hold the loaded
 * entity, so consumers get the answer synchronously and route guards never redirect while a
 * lookup is still pending.
 *
 * Defaults to false, so any consumer rendered outside a provider behaves exactly as before.
 */
const EntityVpContext = createContext(false);

export const EntityVpProvider = EntityVpContext.Provider;

export const useIsEntityVp = () => useContext(EntityVpContext);
